import axios from 'axios';
import { authService } from '../../services/authService';

/** Загрузка файла живёт минуты и переживает access-токен, поэтому у неё свой
 *  кред. Вынесено из RecognitionScreen отдельным модулем: так проверяется без
 *  монтирования экрана и не смешивается с общим post, который обслуживает
 *  опрос статуса, протокол, чат и источники meeting/link. */
export function makePostUpload() {
  return async (url, body, opts = {}) =>
    axios.post(url, body, { ...opts, headers: await authService.getUploadHeaders() });
}
